// Protected route component that redirects unauthenticated users to login

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { FullScreenFallback } from '@/components/RouteFallback';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // While the initial session is resolving (e.g. a silent cookie-refresh after
  // an OAuth redirect, where no access token is in localStorage yet), wait
  // instead of bouncing to /login — otherwise a just-authenticated user would
  // be stranded on the login page before the refresh completes.
  if (isLoading) {
    return <FullScreenFallback />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname + location.search }}
        replace
      />
    );
  }

  return <Outlet />;
}
